import { useTranslation } from "react-i18next";
import { PinnableCell, useEstimateTableSettings } from "@tools";
import { TimelineRowActions } from "./TimelineRowActions";
import { Grid } from "@material-ui/core";
import classnames from "classnames";
import { bool, node, number, object } from "prop-types";

export const TitleCell = ({
  workType,
  tableDepth,
  children,
  isOpened,
}) => {
  const { t } = useTranslation();
  const { useExpandCell } = useEstimateTableSettings();
  
  const { name } = workType;
  
  return (
    <PinnableCell
      boldText
      colName="title"
      pinnedLeft
      hasStaticWidth
      tableDepth={tableDepth}
      allowOverflowDisplay
      actions={
        <TimelineRowActions
          workType={workType}
          opened={isOpened}
        />
      }
      containers={children}
    >
      <Grid
        item
        container
        alignItems="center"
        className={classnames(
          "name",
          "preset-timelineTitleText",
          !useExpandCell && "ml-3",
          !name?.length && "semi-transparent"
        )}
      >
        {name || t("common.unnamed")}
      </Grid>
    </PinnableCell>
  )
}

TitleCell.propTypes = {
  workType: object.isRequired,
  tableDepth: number.isRequired,
  children: node,
  isOpened: bool,
}